module.exports = __webpack_public_path__ + "static/media/icons8-google-drive.6cc9670c.svg";